<template>
  <div class=" h-screen w-full bg-gray-300">
    <div >
      <div class="flex flex-col w-full pl-4">

          <div class="w-full pb-3 text-gray-900 text-2xl font-bold">Soporte ChAPPultepec</div>
          <div class="d-flex justify-content-start" >
			  <p>Si necesita soporte o ayuda con la aplicación "ChAPPultepec" envíenos un correo a developers.cgeo@gmail.com y con gusto le atenderemos.
			  </p>
			  <p><br></p>
			  
		

          </div>


         

      </div>
    </div>
    <reset-password-modal
            :showing="showResetPasswordModal"
            @close="showResetPasswordModal = false"
          ></reset-password-modal>
  </div>
</template>

<style scoped>
</style>

<script>
import { mapState, mapActions } from "vuex";
import ResetPassword from "./ResetPassword";

export default {
  data() {
    return {
      email: "",
      password: "",
      showResetPasswordModal: false,
    };
  },
  components: {
    'reset-password-modal': ResetPassword
  },
  computed: {
    ...mapState(["loggingIn", "loginError", "accessToken"])
  },
  methods: {
    ...mapActions(["doLogin"]),
    loginSubmit() {
      this.doLogin({
        email: this.email,
        password: this.password,
        type: "monitor"
      });
    },
    openResetPasswordModal(){
      this.showResetPasswordModal = true;
    }
  }
};
</script>
